import React from 'react';

export default function XoaDuLieu() {
  return (
    <div className="max-w-xl mx-auto mt-10 p-6 bg-white rounded shadow text-gray-800">
      <h1 className="text-xl font-bold mb-4">Yêu cầu xóa dữ liệu Facebook</h1>
      <p>
        Nếu bạn muốn xóa dữ liệu liên quan đến tài khoản Facebook của mình khỏi hệ thống của chúng tôi,
        vui lòng gửi yêu cầu qua email: <a href="mailto:support@myu.vn" className="text-blue-600 underline">support@myu.vn</a>
        hoặc nhấn vào nút bên dưới.
      </p>
      <a
        href="mailto:support@myu.vn?subject=Yêu cầu xóa dữ liệu Facebook"
        className="inline-block mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
      >
        Gửi yêu cầu xóa dữ liệu
      </a>
      <div className="mt-6 text-sm text-gray-500">
        Nếu bạn truy cập trang này từ Facebook, chúng tôi sẽ xử lý yêu cầu xóa dữ liệu của bạn theo chính sách của Facebook.
      </div>
    </div>
  );
}
